declare var process: any;

if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require.");
}

declare var diy: {
    website: {
        layout: LayoutDataStructure;
    }
};

interface LayoutDataStructure {
    id: number;
    theming: boolean;
}

class Data {
    constructor(protected data: LayoutDataStructure) {
    }
    getId() {
        return this.data.id;
    }
    hasTheming() {
        return this.data.theming;
    }
}

export let layoutData = new Data(diy.website.layout);



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/layoutData.ts
 **/